// These methods below are extracted from the templates
// The templates originally used a lot of `onclick="javascript-here()`

const selectKindergarten = document.getElementById('gotokindergarten');
const locationInput = document.getElementById('location-input');
const searchArea = document.getElementById('searcharea');
const searchhours = document.getElementById('searchhours');
const searchage = document.getElementById('searchage');
const searchpacifickindergartens = document.getElementById('searchpacifickindergartens');
const geolocateAround = document.getElementById('geolocate-around');
const returnFalses = Array.from(document.getElementsByClassName('js-return-false'));
const prints = Array.from(document.getElementsByClassName('js-print'));
const newsCards = Array.from(document.getElementsByClassName('news-card'));

if (selectKindergarten) {
    selectKindergarten.addEventListener("change", () => {
        document.location.href = selectKindergarten.value
    });
}
if (locationInput) {
    locationInput.addEventListener('focus', () => {
        locationInput.value = '';
    });
}
if (searchArea) {
    searchArea.addEventListener("change", () => {
        filterSuburbs(searchArea.value);
    });
}
if (searchhours) {
    searchhours.addEventListener("change", () => {
        filterHours(searchhours.value);
    });
}
if (searchage) {
    searchage.addEventListener("change", () => {
        filterAge(searchage.value);
    });
}

if (searchpacifickindergartens) {
    searchpacifickindergartens.addEventListener("change", () => {
        filterPacificKindergartens(searchpacifickindergartens.value);
    });
}

if (geolocateAround) {
    geolocateAround.addEventListener('click', () => {
        userGeolocate();
    });
}
if (returnFalses.length) {
    returnFalses.forEach(elm => {
        elm.addEventListener('click', () => {
            return false;
        })
    });
}
if (prints.length) {
    prints.forEach(elm => {
        elm.addEventListener('click', () => {
            window.print();
            return false;
        })
    });
}

/**
 * Open news links regardless of where you click on any given news card
 */
if (newsCards.length) {
    newsCards.forEach(elm => {
        elm.addEventListener('click', (e) => {
            const clicked = e.originalTarget;
            if (clicked.tagName !== 'A') {
                window.location.href = clicked.closest('.news-col').querySelector('a');
            }
        })
    });
}

/**
 *  We need to dynamically update the <main> padding to take into account the height of the fixed nav
 */
document.addEventListener('DOMContentLoaded', function() {

    function setMainPadding() {
        var fixedNav = document.getElementById('main-nav');
        var mainElement = document.querySelector('main');
        var fixedNavHeight = fixedNav.offsetHeight;
        mainElement.style.paddingTop = fixedNavHeight + 'px';
    }

    // Set the padding when the DOM is loaded
    setMainPadding();

    // Adjust the padding on window resize
    window.addEventListener('resize', setMainPadding);
});

